import styled from 'styled-components';

export const PaddedContainer = styled.div`
  padding: 256px;
`;

export const WavelightsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  table {
    width: 100%;
  }
`;

export const TimeBlock = styled.div`
  display: flex;
  flex-direction: column;
`;
